var map = {
	"./skin1/tabbar_icon_service@3x.png": "54dc",
	"./skin2/tabbar_icon_service@3x.png": "15df",
	"./skin3/tabbar_icon_service@3x.png": "a7d7",
	"./skin4/tabbar_icon_service@3x.png": "d7a0",
	"./skin5/tabbar_icon_service@3x.png": "7237",
	"./skin6/tabbar_icon_service@3x.png": "c97e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb39";